import styled from "styled-components";

import { TB } from "../texts";

export const AddButton = ({ label, onClick }) => {
    return (
        <AddButtonStyled onClick={() => onClick()}>
            <TB underline link>
                + {label}
            </TB>
        </AddButtonStyled>
    );
};

export default AddButton;

const AddButtonStyled = styled.span``;
